<template>
  <div class="download-progress d-flex align-items-center">
    <div class="download-progress__track small my-2 flex-grow-1">
      <div class="download-progress__bar" :style="{ width: displayedPerc + '%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadProgress',
  props: {
    totalFiles: {
      type: Number,
      required: true
    },
    downloadedFiles: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      displayedPerc: 0
    }
  },
  computed: {
    progressPerc() {
      if (this.totalFiles === 0) return 0
      return Math.min(100, (this.downloadedFiles / this.totalFiles) * 100)
    }
  },
  mounted() {
    // Defer initial paint so the CSS transition animates from 0 to the
    // current value (otherwise a remount at e.g. 50% would skip the fill).
    this.$nextTick(() => {
      this.displayedPerc = this.progressPerc
    })
  },
  watch: {
    progressPerc(val) {
      this.displayedPerc = val
    }
  }
}
</script>

<style scoped>
.download-progress__track {
  height: 6px;
  background-color: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
}

.download-progress__bar {
  height: 100%;
  background-color: #2eb85c;
  border-radius: 3px;
  transition: width 0.8s ease-out;
}
</style>
